var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import colors from '../utils/colors';
var colorVariation = function (_a) {
    var text = _a.text, background = _a.background, border = _a.border, hoverBackground = _a.hoverBackground, hoverBorder = _a.hoverBorder, hoverColor = _a.hoverColor, borderRadius = _a.borderRadius;
    return "\n  color: " + text + ";\n  border-color: " + border + ";\n  background-color: " + background + ";\n  " + (borderRadius && "border-radius: " + borderRadius) + "\n  \n  &:hover {\n    color: " + (hoverColor || text) + ";\n    border-color: " + hoverBorder + ";\n    background-color: " + hoverBackground + ";\n  }\n  &:active {\n    color: " + text + ";\n    border-color: " + hoverBorder + ";\n    background-color: " + hoverBackground + ";\n  }\n";
};
var buttonWidth = 140;
var buttonHeight = 30;
var BrandButtonBase = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.58px;\n  line-height: 14px;\n  text-transform: uppercase;\n\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  &:active {\n    transform: scale(", ", ", ");\n  }\n\n  border-width: 1px;\n  border-style: solid;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.58px;\n  line-height: 14px;\n  text-transform: uppercase;\n\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  &:active {\n    transform: scale(", ", ", ");\n  }\n\n  border-width: 1px;\n  border-style: solid;\n\n  &:focus {\n    outline: none;\n  }\n"])), buttonWidth, buttonHeight, buttonHeight / 2, (buttonWidth - 2) / buttonWidth, (buttonHeight - 2) / buttonHeight);
export var BrandButtonPrimary = styled(BrandButtonBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  font-weight: 700;\n"], ["\n  ",
    "\n  font-weight: 700;\n"])), function (props) {
    return colorVariation({
        text: colors.WHITE,
        background: props.theme.secondaryColor || colors.GREEN_DARK,
        border: props.theme.secondaryColor || colors.GREEN_DARK,
        hoverBackground: props.theme.secondaryColorLight || colors.GREEN_DARKEST,
        hoverBorder: props.theme.secondaryColorDarkLight || colors.GREEN_DARKEST,
        borderRadius: props.theme.buttonBorderRadius,
    });
});
export var BrandButtonSecondary = styled(BrandButtonBase)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    return colorVariation({
        text: props.theme.primaryColorLight || colors.GREEN_DARK,
        background: colors.TRANSPARENT,
        border: props.theme.primaryColorLight || colors.GREEN_DARK,
        hoverBackground: props.theme.primaryColorLighter || colors.GREEN_LIGHTEST,
        hoverBorder: props.theme.primaryColorLight || colors.GREEN_DARK,
        borderRadius: props.theme.buttonBorderRadius,
    });
});
export var BrandButtonTertiary = styled(BrandButtonBase)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    return colorVariation({
        text: props.theme.fontColorDark || colors.TITLE_DEFAULT,
        background: colors.TRANSPARENT,
        border: props.theme.tertiaryColor || colors.TITLE_DEFAULT,
        hoverBackground: props.theme.tertiaryColorLight || colors.BLUE_LIGHTEST,
        hoverBorder: props.theme.tertiaryColor || colors.TITLE_DEFAULT,
        hoverColor: props.theme.fontColorDark || colors.TITLE_DEFAULT,
        borderRadius: props.theme.buttonBorderRadius,
    });
});
export var BrandButtonNegative = styled(BrandButtonBase)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    return colorVariation({
        text: props.theme.primaryColorLight || colors.RED,
        background: colors.TRANSPARENT,
        border: props.theme.primaryColorLight || colors.RED,
        hoverBackground: props.theme.primaryColorLighter || colors.RED_LIGHTEST,
        hoverBorder: props.theme.primaryColorLight || colors.RED,
        hoverColor: props.theme.primaryColorLight || colors.RED,
        borderRadius: props.theme.buttonBorderRadius,
    });
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=BrandButton.js.map